import classes from "./ExpandableMenu.module.css"
import classNames from "classnames"
import React from "react"
import { lightBlack } from "../../../themes/variables"
import { ExpandButton } from "../../atoms/IconButton/buttons/expand"
import { Collapse } from "../../animations/Collapse"

export interface ExpandableMenuProps {
  expanded?: boolean
  onToggle?: (newValue: boolean) => void
  label?: React.ReactNode
  children: any
  className?: string
}

const ExpandableMenu = ({
  expanded,
  onToggle,
  label,
  children,
  className,
}: ExpandableMenuProps) => {
  return (
    <div className={className}>
      <div className={classes.head} onClick={() => onToggle?.(!expanded)}>
        <div
          className={classNames(classes.label, {
            [classes.labelExpanded]: expanded,
          })}
        >
          {label}
        </div>
        <div
          className={classNames(classes.separator, {
            [classes.separatorExpanded]: expanded,
          })}
        />
        <div>
          <ExpandButton
            expanded={expanded}
            color={lightBlack}
            size={20}
            className={classes.expandButton}
          />
        </div>
      </div>
      <Collapse in={expanded ?? false}>
        <div className={classes.content}>{children}</div>
      </Collapse>
    </div>
  )
}

export default ExpandableMenu
